import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'substring'
})
export class SubstringPipe implements PipeTransform {

  transform(str: string, charLimit: number, tail?: string): string {
    let result = ``;

    if (!tail) {
      tail = ``;
    }

    if (str) {

      if (str.length > charLimit) {

        result = str.trim().substring(0, charLimit).trim();
        result += tail;

      } else {
        result = str;
      }
    }

    return result;
  }

}
